import { formatDateOfBirth } from "utils/dateFormatter";

import styles from "../MergePatientsPage.module.css";

const formatAddress = (patient) => {
  const { addressLine1, addressLine2, city, postCode } = patient?.address ?? {};

  return [addressLine1, addressLine2, [city, postCode].filter(Boolean).join(" ")]
    .filter(Boolean)
    .join(", ");
};

// The patient record is not guaranteed to carry a registration date — it is whatever
// the core entity exposes — so the row is shown only when there is a real date to show,
// rather than printing a dash and implying the record has no history.
const formatRegistered = (patient) => {
  const registered = patient?.created ?? patient?.createdDate;
  const formatted = registered ? formatDateOfBirth(registered) : "";

  return formatted === "—" ? "" : formatted;
};

// Enough to tell two records apart before anything is moved between them: the names
// match by definition on this screen, so what distinguishes them is the identifiers,
// the contact details, the address and — where the record carries it — when it was
// registered. A blank row is shown as blank rather than hidden, because "this one has
// no PPS number" is itself part of the decision.
const DetailRow = ({ label, value }) => (
  <div className={styles.detailRow}>
    <dt>{label}</dt>
    <dd>{value || "—"}</dd>
  </div>
);

export const MergeRecordCard = ({
  patient,
  isSurvivor,
  onChooseSurvivor,
  isChoiceDisabled,
}) => {
  const name = [patient?.firstName, patient?.surname].filter(Boolean).join(" ");
  const registered = formatRegistered(patient);

  return (
    <section
      className={`${styles.recordCard} ${isSurvivor ? styles.recordCardSurvivor : ""}`}
    >
      <header className={styles.recordCardHeader}>
        <h4 className={styles.recordCardName}>{name || "Unnamed patient"}</h4>
        {!!patient?.died && <span className={styles.recordCardFlag}>Deceased</span>}
      </header>
      <dl className={styles.recordCardDetails}>
        <DetailRow label="Date of birth" value={formatDateOfBirth(patient?.dateOfBirth)} />
        <DetailRow label="PPS number" value={patient?.nationalNumber} />
        <DetailRow label="IHI number" value={patient?.ihiNumber} />
        <DetailRow label="Medical card" value={patient?.medicalCardNumber} />
        <DetailRow label="Phone" value={patient?.mobilePhone || patient?.homePhone} />
        <DetailRow label="Email" value={patient?.email} />
        <DetailRow label="Address" value={formatAddress(patient)} />
        {!!registered && <DetailRow label="Registered" value={registered} />}
      </dl>
      <label className={styles.survivorChoice}>
        <input
          type="radio"
          name="merge-survivor"
          checked={isSurvivor}
          onChange={() => onChooseSurvivor(patient.id)}
          disabled={isChoiceDisabled}
        />
        <span>Keep this record</span>
      </label>
    </section>
  );
};
